import {City} from './city';

export class Place {
	public id: string;
	public address: string;
	public postal_code: string;
	public city: City;
	public prefix: string;

	constructor(server_obj: any) {
		this.prefix = 'plc_';
		if (server_obj) {
			this.id          = server_obj[this.prefix + 'id'];
			this.address     = server_obj[this.prefix + 'address'];
			this.postal_code = server_obj[this.prefix + 'postal_code'];
			this.city   = new City(server_obj);
		} else {

		}
	}
}
